import { render, staticRenderFns } from "./PropertyIncomeEligibleTable.vue?vue&type=template&id=db09bafa"
import script from "./PropertyIncomeEligibleTable.vue?vue&type=script&lang=js"
export * from "./PropertyIncomeEligibleTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports